export default {
  app: {
    languagePopup: {
      title: '您目前使用的是 {logo} 的英文頁面',
      subtitle: '您是否希望切換到您的偏好語言？',
      cta: '切換到 {lang}',
    },
  },
};
